import { render, staticRenderFns } from "./CarriersCard.vue?vue&type=template&id=a138f87e&scoped=true"
import script from "./CarriersCard.vue?vue&type=script&lang=js"
export * from "./CarriersCard.vue?vue&type=script&lang=js"
import style0 from "./CarriersCard.vue?vue&type=style&index=0&id=a138f87e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138f87e",
  null
  
)

export default component.exports